export default __webpack_public_path__ + "static/media/headshot2.46f25982.png";